import { FormControl } from 'baseui/form-control'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddress from '../../useAddress'

const CookingEnergy = () => {
  const { t, updateAddress, cookingEnergy, cookingOptions } = useAddress()

  return (
    <FormControl>
      <SDSelect
        label={t('subscriptionTools:estimator.cooking_mode.label')}
        optionsList={cookingOptions}
        onChangeHandler={params => updateAddress({ cookingEnergy: params.option?.id })}
        selectedValue={cookingEnergy ? cookingEnergy.toString() : ''}
        hasError={false}
      />
    </FormControl>
  )
}
export default CookingEnergy
